import { brand } from "../context";

export function getFontFamily() {
  switch (brand) {
    case "easy":
      return "futura-pt,sans-serif";
    case "mse":
      return '"Josefin Sans",sans-serif';
    case "thehotelco":
      return "Poppins";
    case "isg":
      return '"Josefin Sans",sans-serif';
    case "cst":
      return '"Josefin Sans",sans-serif';
    case "mycarte":
      return '"Josefin Sans",sans-serif';
    case "soulatravel":
      return '"Josefin Sans",sans-serif';
    case "corporatetravelclub":
      return '"Josefin Sans",sans-serif';
    case "unionshopper":
      return '"Josefin Sans",sans-serif';
    case "infinite":
      return "'Frank Ruhl Libre', serif";
    case "tmdh":
      return "'Jost', sans-serif";
    case "clubseacret":
      return "'rivieranights', Arial";
    case "fightzone":
      return "'Founders Grotesk', Arial, sans-serif";
    case "travelingtime":
      return "verdana, geneva";
    case "fluturolire":
      return "Poppins";
    case "flymenow":
      return "Open Sans";
    case "oasis":
      return "Open Sans";
    case "innstanttravel":
      return "Poppins";
    case "mytravellifestyle":
      return "Raleway, Helvetica";
    case "hgv":
      return "Open Sans";
    case "travily":
      return "'Lato', sans-serif";
    case "kemet":
      return "Helvetica Neue";
    case "clubwyndham":
      return "'Work Sans', sans-serif";
    default:
      return "'Roboto', sans-serif";
  }
}

const textStyles = {
  sectionHeaderText: {
    fontWeight: "bold",
    fontStyle: "normal",
    fontSize: "xxx-large",
    fontFamily: getFontFamily(),
  },
  headerText: {
    fontWeight: "bold",
    fontStyle: "normal",
    fontSize: "x-large",
    fontFamily: getFontFamily(),
  },
  normalText: {
    fontWeight: "normal",
    fontStyle: "normal",
    fontSize: "large",
    fontFamily: getFontFamily(),
  },
  brandText: {
    fontWeight: "400",
    fontStyle: "normal",
    fontFamily: getFontFamily(),
  },
};

export function getFontStyles() {
  switch (brand) {
    case "easy":
      return {
        sectionHeaderText: {
          ...textStyles.sectionHeaderText,
        },
        headerText: {
          ...textStyles.headerText,
        },
        normalText: {
          ...textStyles.normalText,
        },
        brandText: {
          ...textStyles.brandText,
          fontFamily: "cooper-black-std,serif",
        },
      };
    case "mse":
      return {
        sectionHeaderText: {
          ...textStyles.sectionHeaderText,
          fontFamily: "'Playfair Display', serif",
        },
        headerText: {
          ...textStyles.headerText,
          fontFamily: "'Playfair Display', serif",
        },
        normalText: {
          ...textStyles.normalText,
        },
        brandText: {
          ...textStyles.brandText,
        },
      };
    case "thehotelco":
      return {
        sectionHeaderText: {
          ...textStyles.sectionHeaderText,
        },
        headerText: {
          ...textStyles.headerText,
        },
        normalText: {
          ...textStyles.normalText,
        },
        brandText: {
          ...textStyles.brandText,
        },
      };
    case "isg":
      return {
        sectionHeaderText: {
          ...textStyles.sectionHeaderText,
        },
        headerText: {
          ...textStyles.headerText,
        },
        normalText: {
          ...textStyles.normalText,
        },
        brandText: {
          ...textStyles.brandText,
        },
      };
    case "cst":
      return {
        sectionHeaderText: {
          ...textStyles.sectionHeaderText,
        },
        headerText: {
          ...textStyles.headerText,
        },
        normalText: {
          ...textStyles.normalText,
        },
        brandText: {
          ...textStyles.brandText,
        },
      };
    case "mycarte":
      return {
        sectionHeaderText: {
          ...textStyles.sectionHeaderText,
        },
        headerText: {
          ...textStyles.headerText,
        },
        normalText: {
          ...textStyles.normalText,
        },
        brandText: {
          ...textStyles.brandText,
        },
      };
    case "soulatravel":
      return {
        sectionHeaderText: {
          ...textStyles.sectionHeaderText,
        },
        headerText: {
          ...textStyles.headerText,
        },
        normalText: {
          ...textStyles.normalText,
        },
        brandText: {
          ...textStyles.brandText,
        },
      };
    case "corporatetravelclub":
      return {
        sectionHeaderText: {
          ...textStyles.sectionHeaderText,
        },
        headerText: {
          ...textStyles.headerText,
        },
        normalText: {
          ...textStyles.normalText,
        },
        brandText: {
          ...textStyles.brandText,
        },
      };
    case "unionshopper":
      return {
        sectionHeaderText: {
          ...textStyles.sectionHeaderText,
        },
        headerText: {
          ...textStyles.headerText,
        },
        normalText: {
          ...textStyles.normalText,
        },
        brandText: {
          ...textStyles.brandText,
        },
      };
    case "infinite":
      return {
        sectionHeaderText: {
          ...textStyles.sectionHeaderText,
        },
        headerText: {
          ...textStyles.headerText,
        },
        normalText: {
          ...textStyles.normalText,
        },
        brandText: {
          ...textStyles.brandText,
        },
      };
    case "tmdh":
      return {
        sectionHeaderText: {
          ...textStyles.sectionHeaderText,
        },
        headerText: {
          ...textStyles.headerText,
        },
        normalText: {
          ...textStyles.normalText,
        },
        brandText: {
          ...textStyles.brandText,
        },
      };
    case "clubseacret":
      return {
        sectionHeaderText: {
          ...textStyles.sectionHeaderText,
        },
        headerText: {
          ...textStyles.headerText,
        },
        normalText: {
          ...textStyles.normalText,
        },
        brandText: {
          ...textStyles.brandText,
        },
      };
    case "fightzone":
      return {
        sectionHeaderText: {
          ...textStyles.sectionHeaderText,
        },
        headerText: {
          ...textStyles.headerText,
        },
        normalText: {
          ...textStyles.normalText,
        },
        brandText: {
          ...textStyles.brandText,
        },
      };
    case "flymenow":
      return {
        sectionHeaderText: {
          ...textStyles.sectionHeaderText,
          fontFamily: "Playfair Display",
          fontWeight: 400,
        },
        headerText: {
          ...textStyles.headerText,
        },
        normalText: {
          ...textStyles.normalText,
        },
        brandText: {
          ...textStyles.brandText,
        },
      };
    case "oasis":
      return {
        sectionHeaderText: {
          ...textStyles.sectionHeaderText,
          fontFamily: "Open Sans",
        },
        headerText: {
          ...textStyles.headerText,
        },
        normalText: {
          ...textStyles.normalText,
        },
        brandText: {
          ...textStyles.brandText,
        },
      };
    default:
      return textStyles;
  }
}
